import { canRead, canWrite } from '../access/rbacAccess'

export const ESSENTIALS = {
  LIST: 'planifica.essentials'
}

export const canViewEssentials = () => canRead(ESSENTIALS.LIST)

export const canManageEssentials = () => canWrite(ESSENTIALS.LIST)
